export default __webpack_public_path__ + "static/media/thumbnail.d391ffcf.png";